<template>
  <section id="resolution_container">
    <div class="columns">
      <div class="column">
        <CompanySelector v-model="company"/>
      </div>
      <div class="column">
        <b-field label="Prefijo">
          <b-input
              placeholder="Ingrese el prefijo"
              type="text"
              name="prefix"
              v-model="prefix"
              v-validate="'required'"/>
        </b-field>
        <span class="show-error">{{ errors.first("date1") }}</span>
      </div>
      <div class="column">
        <b-field label="Título">
          <b-input
              placeholder="Ingrese el título"
              type="text"
              name="title"
              v-model="title"
              v-validate="'required'"/>
        </b-field>
        <span class="show-error">{{ errors.first("title") }}</span>
      </div>
    </div>
    <div class="columns">
      <div class="column is-4 group-control">
        <b-field label="Dispositivo">
          <div class="control-content">
            <b-select
                placeholder="Dispositivo"
                name="device"
                v-model="device"
                v-validate="'required'">
              <option
                  v-for="option in devices"
                  :value="option.code"
                  :key="option.code"
                  :id="option.code">
                {{ getDeviceLabel(option) }}
              </option>
            </b-select>
          </div>
          <vs-button
              color="primary"
              class="pl-5 pr-5 control-btn"
              type="filled"
              icon="refresh"
              title="Actualizar lista"
              @click="getDevices(true)"/>
        </b-field>
        <span class="show-error">{{ errors.first("device") }}</span>
      </div>
      <div class="column">
        <b-field label=" Fecha Inicial">
          <b-datepicker
              v-validate="'required'"
              v-model="initialDate"
              placeholder="Seleccione una fecha..."
              icon="calendar-today"
              name="date1"/>
        </b-field>
        <span class="show-error">{{ errors.first("date1") }}</span>
      </div>
      <div class="column">
        <b-field label=" Fecha Final">
          <b-datepicker
              v-validate="'required'"
              v-model="finalDate"
              placeholder="Seleccione una fecha..."
              icon="calendar-today"
              name="date2"/>
        </b-field>
        <span class="show-error">{{ errors.first("date2") }}</span>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <b-field label="Valor Inicial">
          <b-input
              placeholder="Ingrese un valor..."
              type="text"
              v-model="initialValue"
              v-validate="'required|numeric|min_value:0'"
              name="initialValue"/>
        </b-field>
        <span class="show-error">{{ errors.first("initialValue") }}</span>
      </div>
      <div class="column">
        <b-field label="Valor Final">
          <b-input
              placeholder="Ingrese un valor..."
              type="text"
              v-model="finalValue"
              v-validate="'required|numeric|min_value:0'"
              name="finalValue"/>
        </b-field>
        <span class="show-error">{{ errors.first("finalValue") }}</span>
      </div>
      <div class="column">
        <b-field label="Valor Actual">
          <b-input
              placeholder="Ingrese un valor..."
              type="text"
              v-model="currentValue"
              v-validate="'required|numeric|min_value:0'"
              name="currentValue"/>
        </b-field>
        <span class="show-error">{{ errors.first("currentValue") }}</span>
      </div>
    </div>
    <div class="columns">
      <div class="column is-4 ">
        <b-field label="Liquidación">
          <multiselect v-model="selectedLiquidations" placeholder="Liquidaciones"
                       label="title"
                       :close-on-select="false"
                       track-by="code" :options="liquidations" :multiple="true" :taggable="true"/>
        </b-field>
        <span class="show-error">{{ errors.first("liquidation") }}</span>
      </div>
      <div class="column is-4 ">
        <b-field label="Número de Resolución">
          <b-input
              placeholder="Ingrese el número de resolución"
              type="text"
              name="resolutionNumber"
              v-model="resolutionNumber"
              v-validate="'required|numeric|min_value:1'"
              maxlength="50"/>
        </b-field>
        <span class="show-error">{{ errors.first("resolutionNumber") }}</span>
      </div>
      <div class="column is-4 ">
        <b-field label="Tipo de Resolución">
          <div class="control-content">
            <b-select
                placeholder="Seleccione un tipo de resolución"
                name="resolutionType"
                v-model="resolutionType"
                v-validate="'required'">
              <option
                  v-for="option in resolutionTypes"
                  :value="option.initial"
                  :key="option.initial"
                  :id="option.initial">
                {{ option.title }}
              </option>
            </b-select>
          </div>
        </b-field>
        <span class="show-error">{{ errors.first("resolutionType") }}</span>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <b-field label="Cabecera otros">
          <b-input
              placeholder="Ingrese aquí la información adicional que desea mostrar en la impresión"
              type="text"
              name="header"
              v-model="header"/>
        </b-field>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <b-field label="Pie de página">
          <b-input
              placeholder="Ingrese el pie de página"
              type="textarea"
              name="footer"
              v-model="footer"/>
        </b-field>
      </div>
    </div>
    <div class="buttons button-group">
      <b-button @click="save()" type="is-info"> Guardar</b-button>
      <b-button @click="cleanForm()" v-if="id != null" type="is-info">Limpiar</b-button>
      <b-button
          @click="openDeleteModal()"
          v-if="id != null"
          type="is-danger"
          icon-right="delete">
        Eliminar
      </b-button>
    </div>

    <b-loading :is-full-page="true" v-model="isLoading"></b-loading>
  </section>
</template>

<script>
import moment from "moment";
import CompanySelector from "../../components/Shared/CompanySelector";
import {ROUTES} from "@/global/api_routes";
import {get as getProp} from "object-path";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import {confirmation} from "@/global/utils";
import Multiselect from "vue-multiselect";

export default {
  name: "CreateCompany",
  components: {CompanySelector, Multiselect},
  props: ['resolutionId'],
  data: () => ({
    id: null,
    company: null,
    device: null,
    selectedLiquidations: [],
    liquidations: [],
    title: null,
    initialDate: null,
    finalDate: null,
    selected: null,
    tableData: [],
    initialValue: 0,
    finalValue: 0,
    currentValue: 0,
    companies: [],
    isLoading: false,
    prefix: null,
    header: null,
    footer: null,
    devices: [],
    resolutionNumber: '0',
    resolutionType: "EQUIVALENT",
    resolutionTypes: [
      {initial:"EQUIVALENT" , title: 'Resolución equivalente'},
      {initial:"ELECTRONIC" , title: 'Resolución electrónica'},
      {initial:"CONTINGENCY" , title: 'Resolución de contingencia'},
    ],
  }),
  mounted() {
    if (this.resolutionId) {
      this.findResolutionById(this.resolutionId);
    }
  },
  watch: {
    async company() {
      if (!this.company) {
        this.selected = null;
        return;
      }
      this.isLoading = true;
      await this.getDevices(false);
      await this.getLiquidations();
      this.isLoading = false;
    },
    selected() {
      if (this.selected != null) {
        this.fillData(this.selected);
      }
    },
  },
  methods: {
    findResolutionById(id) {
      this.isLoading = true;
      this.$http.get(ROUTES.DASHBOARD.RESOLUTION.GET_FIND_BY_CODE, {
        params: {resolutionId: id}
      }).then(({data}) => {
        if (data.code <= 0) {
          this.$router.push({name: "Resolución"});
          return;
        }
        const info = data.info;
        this.company = info.company.code;
        this.fillData(info);
      }).finally(() => {
        this.isLoading = false;
      });
    },
    getDeviceLabel(option) {
      return `${option.title} - (${getProp(option, "deviceType.title")})`;
    },
    getLiquidations() {
      this.isLoading = true;
      return new Promise((resolve) => {
        this.$http
            .get(ROUTES.DASHBOARD.RESOLUTION.GET_LIQUIDATIONS, {
              params: {
                companyId: this.company,
              },
            })
            .then(({data}) => {
              this.liquidations = [];
              if (data.code > 0) {
                this.liquidations = data.info;
              }
            })
            .finally(() => {
              this.isLoading = false;
              resolve();
            });
      });
    },
    getDevices(show) {
      if (show && !this.company) {
        this.$toastError("Debe seleccionar una empresa");
        return;
      }
      this.isLoading = true;
      return new Promise((resolve) => {
        this.$http
            .get(ROUTES.DASHBOARD.RESOLUTION.GET_DEVICES, {
              params: {
                companyCode: this.company,
              },
            })
            .then(({data}) => {
              if (data.code > 0) {
                this.devices = data.info;
                this.fillData(this.selected);
                return;
              }
              this.devices = [];
            })
            .finally(() => {
              this.isLoading = false;
              resolve();
            });
      });
    },
    deleteRow(row) {
      confirmation(this, "¿Deseas eliminar el registro?")
          .then((result) => {
            if (!result) {
              return;
            }
            this.isLoading = true;
            this.$http
                .delete(ROUTES.DASHBOARD.DISCOUNTS.DELETE_DISCOUNT, {
                  voucherId: row.code,
                })
                .then(({data}) => {
                  if (data.code > 0) {
                    this.$toastOk("Se ha eliminado el registro");
                    return;
                  }
                  this.$toastError(data.message);
                })
                .finally(() => {
                  this.isLoading = false;
                });
          });
    },
    processData(companies) {
      for (let index = 0; index < companies.length; index++) {
        let company = companies[index];
        company.label = company.name;
        company.id = company.code;
        if (company.children) {
          this.processData(company.children);
        }
      }
    },
    getNormalDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },

    validations() {
      const {initialDate, finalDate, initialValue, finalValue, currentValue} =
          this;
      if (!this.resolutionNumber || this.resolutionNumber === '0' || parseInt(this.resolutionNumber) <= 0) {
        this.$toastError('El número de resolución es obligatorio y debe ser mayor a 0');
        return false;
      }
      const momentInicial = moment(initialDate);
      const momentFinal = moment(finalDate);
      if (momentInicial.isAfter(momentFinal)) {
        this.$toastError('La fecha inicial no puede ser menor a la final');
        return false;
      }
      if (parseInt(initialValue) > parseInt(finalValue)) {
        this.$toastError("El valor inicial no puede ser mayor al valor final");
        return false;
      }
      if (parseInt(finalValue) <= parseInt(initialValue)) {
        this.$toastError("El valor final debe ser mayor al inicial");
        return false;
      }
      if (
          parseInt(currentValue) > parseInt(finalValue) ||
          parseInt(currentValue) < parseInt(initialValue)
      ) {
        this.$toastError("El valor actual debe estar entre el valor inicial y el valor final");
        return false;
      }
      return true;
    },
    save() {
      this.$validator.validateAll().then((result) => {
        if (!result || !this.validations()) {
          return;
        }
        if (!this.resolutionNumber || this.resolutionNumber === '0') {
          this.$toastError('El número de resolución es obligatorio y debe ser mayor a 0');
          return;
        }
        const send = {
          code: this.id,
          company: {
            code: this.company,
          },
          resolution: this.resolutionNumber,
          prefix: this.prefix,
          title: this.title,
          header: this.header,
          footer: this.footer,
          initialDate: this.getNormalDate(this.initialDate),
          finalDate: this.getNormalDate(this.finalDate),
          initialValue: this.initialValue,
          finalValue: this.finalValue,
          currentValue: this.currentValue,
          resolutionList: this.selectedLiquidations.map(item => ({
            device: this.device,
            liquidation: item,
            type: this.resolutionType
          }))
        };
        if (send.code === null) {
          delete send.code;
        }
        this.isLoading = true;
        this.$http
            .post(ROUTES.DASHBOARD.RESOLUTION.SAVE_RESOLUTION, send)
            .then(({data}) => {
              this.isLoading = false;
              if (data.code > 0) {
                this.isLoading = false;
                this.$toastOk(data.message);
                this.cleanForm();
                this.$router.push({name: "Resolución"});
                return;
              }
              this.$toastError(data.message);
            });
      });
    },
    openDeleteModal() {
      confirmation(this, `¿Desea eliminar la resolución?`).then((result) => {
        if (!result) {
          return;
        }
        this.deleteCompany();
      });
    },
    deleteCompany() {
      this.isLoading = true;
      this.$http
          .delete(ROUTES.DASHBOARD.RESOLUTION.DELETE_RESOLUTION, {
            params: {resolutionId: this.id}
          })
          .then(({data}) => {
            this.isLoading = false;
            if (data.code > 0) {
              this.$toastOk(data.message);
              this.cleanForm();
              return;
            }
            this.$toastError(data.message);
          }).finally(() => this.isLoading = false);
    },
    cleanForm() {
      this.id = null;
      this.company = null;
      this.initialDate = null;
      this.finalDate = null;
      this.selected = null;
      this.initialValue = 0;
      this.finalValue = 0;
      this.currentValue = 0;
      this.isLoading = false;
      this.header = null;
      this.footer = null;
      this.title = null;
      this.prefix = null;
      this.device = null;
      this.selectedLiquidations = null;
      this.$validator.reset();
      this.resolutionNumber = '0';
      this.resolutionType = "EQUIVALENT";
    },
    fillData(selected) {
      if (!selected) {
        return;
      }
      this.id = selected.code;
      this.company = selected.company.code;
      this.initialDate = moment(selected.initialDate).toDate();
      this.finalDate = moment(selected.finalDate).toDate();
      this.initialValue = selected.initialValue;
      this.finalValue = selected.finalValue;
      this.currentValue = selected.currentValue;
      this.prefix = selected.prefix;
      this.footer = selected.footer;
      this.header = selected.header;
      this.title = selected.title;
      this.resolutionNumber = selected.resolution || '0';
      if (selected.resolutionList && selected.resolutionList.length > 0) {
        this.device = selected.resolutionList[0].device.code;
        this.selectedLiquidations = selected.resolutionList.map(item => item.liquidation);
        this.resolutionType = selected.resolutionList[0].type || "EQUIVALENT";
      }
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css">
</style>
<style type="scss">
select {
  width: 100%;
}

.btn-save {
  display: flex;
  margin: 0 auto;
  width: 30%;
  justify-content: center;
}

.label {
  font-size: 1em;
}

.header-modal {
  background-color: #2962ff;
}

.modal-button-custom {
  padding: 5px;
  width: 35px;
  height: 35px;
  border-radius: 20px;
  margin-top: 25px;
}

.button-group {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 1.5em;
}

.buttons .button:not(:last-child):not(.is-fullwidth) {
  margin-right: 0.1rem !important;
}

.notices {
  z-index: 1000000000000000000 !important;
}
</style>
